import styled from 'styled-components'

export const SidebarWrapper = styled.div`
  position: sticky;
  left: 0;
  width: 56px;
  border-right: 1px solid #e6e8eb;
  min-height: 100%;
  flex-shrink: 0;
  z-index: 2;
  background-color: #fff;
`

export const HourBlock = styled.div`
  display: flex;
  justify-content: center;
  height: 56px;
  position: relative;
  color: #a1a5b0;
  font-weight: 500;

  span {
    position: absolute;
    top: 0;
    transform: translateY(-50%);
  }
`
